export const dotStartingDecimalRegex = /(\D\.[0-9]+)|(^\.[0-9]+)/;
